import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  d: "M21 3H3V21H21V3Z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14.3906 18H9.45312V17.4297C9.58854 17.4193 9.72135 17.4062 9.85156 17.3906C9.98177 17.375 10.0938 17.349 10.1875 17.3125C10.3542 17.25 10.4714 17.1615 10.5391 17.0469C10.6068 16.9271 10.6406 16.7708 10.6406 16.5781V12.0312C10.6406 11.849 10.599 11.6901 10.5156 11.5547C10.4323 11.4141 10.3281 11.3021 10.2031 11.2188C10.1094 11.1562 9.96615 11.0964 9.77344 11.0391C9.58594 10.9818 9.41406 10.9453 9.25781 10.9297V10.3594L13.0859 10.1562L13.2031 10.2734V16.4766C13.2031 16.6589 13.2422 16.8151 13.3203 16.9453C13.3984 17.0703 13.5104 17.1641 13.6562 17.2266C13.7604 17.2734 13.875 17.3151 14 17.3516C14.125 17.388 14.2552 17.4141 14.3906 17.4297V18ZM13.25 7.34375C13.25 7.73958 13.0964 8.07812 12.7891 8.35938C12.487 8.63542 12.1276 8.77344 11.7109 8.77344C11.2891 8.77344 10.9245 8.63542 10.6172 8.35938C10.3151 8.07812 10.1641 7.73958 10.1641 7.34375C10.1641 6.94792 10.3151 6.60938 10.6172 6.32812C10.9245 6.04688 11.2891 5.90625 11.7109 5.90625C12.1328 5.90625 12.4948 6.04688 12.7969 6.32812C13.099 6.60938 13.25 6.94792 13.25 7.34375Z"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }